import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('insurance-upload')
export class InsuranceEntity {
    @PrimaryGeneratedColumn("increment", { name: 'insurancefile_id' })
  insurancefileId: number;

  @Column("varchar", {
    nullable: false,
    name: "file_path"
  })
  filePath: string;

  @Column("varchar", {
    nullable: false,
    name: "file_Name"
  })
  fileName: string;

  
  @Column("varchar", {
    nullable: false,
    name: "original_name"
  })
  originalname: string;

  @Column("varchar", {
    nullable: false,
    name: "destination"
  })
  destination: string;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;



}